<template>
    <div class="submit-tags">
        <saving v-if="loading" />
        <button v-if="!loading" id="tag-editor-submit" type="button" class="btn btn-primary" @click="submit_tags">
            Save tags
        </button>
    </div>
</template>

<script>
import { addHeaderMessage } from 'src/lib/messages.js'
import apiRequest from 'src/mixins/api-request.js'
import saving from '@/Saving.vue'

export default {
    components: {
        'saving': saving
    },
    mixins: [apiRequest],
    props: {
        submitUrl: {
            type: String,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        message: 'Tags Saved',
    }),
    computed: {
        tagsList: function() {
            let list = []
            for (let tagname of this.tags) {
                list.push({name: tagname})
            }
            return list
        }
    },
    watch: {
        errors: function(value) {
            this.$emit('errors', value)
        }
    },
    methods: {
        submit_tags: function() {
            if (!this.loading) {
                let data = {
                    tags: this.tagsList,
                }

                this.put(this.submitUrl, data)
                .then((response) => {
                    addHeaderMessage(this.message)
                    this.$emit('tags-saved', response.data['tags'])
                })
            }
        }
    },
}
</script>

<style>
.submit-tags {
    display: inline-block;
}
</style>
